import React from 'react'
import {DocCreate} from './Base64'
import PropTypes from 'prop-types'

export default class Icon extends React.Component {
  static propTypes = {
    icon: PropTypes.string
  }

  render() {
    if (!this.props.icon) return null
    if (this.props.icon === 'DocCreate') {
      return <DocCreate />
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/components/SecuritySatModal/Icon/index.js